export var ValueAssetCodeEnum;
(function (ValueAssetCodeEnum) {
    ValueAssetCodeEnum["GEL"] = "GEL";
    ValueAssetCodeEnum["USD"] = "USD";
})(ValueAssetCodeEnum || (ValueAssetCodeEnum = {}));
//# sourceMappingURL=value-asset-code.enum.js.map